import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Linkedin, Twitter, Instagram } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-navy pt-24 pb-12 text-white" data-id="element-24" data-mp="3ghc2o28413o8">
      <div className="max-w-7xl mx-auto px-6" data-id="element-25" data-mp="32ovvqqc38li1">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-20" data-id="element-26" data-mp="32m1ch24t96q7">
          <div className="lg:col-span-2" data-id="element-27" data-mp="36nd6djupwe47">
            <img src="https://cdn.magicpatterns.com/uploads/7fqogpQfYe6LJMG1Tmc1x4/ChatGPT_Image_Jul_13,_2026,_06_34_58_PM.png" alt="Consilium Advisory Logo" className="h-24 w-auto mb-8 object-contain invert" data-id="element-28" data-mp="3ueigrjhw2e74" />
            <p className="text-white/50 max-w-sm mb-8 leading-relaxed" data-id="element-29" data-mp="3lgonyijc22op">
              Consilium Advisory is a premier multidisciplinary firm delivering
              strategic advice, disciplined execution, and lasting partnerships
              to a global clientele.
            </p>
            <div className="flex gap-4" data-id="element-30" data-mp="2ew700loelk6h">
              <a href="#" className="text-white/40 hover:text-brand-gold transition-colors" data-id="element-31" data-mp="3l90l3octskvk">
                <Linkedin size={24} data-id="element-32" data-mp="3gc0hrl7d1w85" />
              </a>
              <a href="#" className="text-white/40 hover:text-brand-gold transition-colors" data-id="element-33" data-mp="3v89cc9gb3le8">
                <Twitter size={24} data-id="element-34" data-mp="3q725qdpwgs95" />
              </a>
              <a href="#" className="text-white/40 hover:text-brand-gold transition-colors" data-id="element-35" data-mp="82qp7jv45dpi">
                <Instagram size={24} data-id="element-36" data-mp="33e6nbb9yssq" />
              </a>
            </div>
          </div>

          <div data-id="element-37" data-mp="hrif7mgm5nxs">
            <h4 className="text-brand-gold font-bold tracking-widest uppercase text-xs mb-8" data-id="element-38" data-mp="hsa8urqnhblf">
              Services
            </h4>
            <ul className="space-y-4 text-white/60 text-sm" data-id="element-39" data-mp="qthxsj7a102u">
              <li data-id="element-40" data-mp="qu1e5vha3ger">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-41" data-mp="qrfboa98vr3e">
                  Tax & Accounting
                </Link>
              </li>
              <li data-id="element-42" data-mp="yu7gspfuzlx5">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-43" data-mp="yto87zc3m9vs">
                  Strategic Advisory
                </Link>
              </li>
              <li data-id="element-44" data-mp="18l2fitaakdzh">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-45" data-mp="18lk7vetu2824">
                  Capital Solutions
                </Link>
              </li>
              <li data-id="element-46" data-mp="1hium991y6db9">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-47" data-mp="1hmibhw0d0dk6">
                  CFO Services
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-48" data-mp="3oc6s71c6n613">
            <h4 className="text-brand-gold font-bold tracking-widest uppercase text-xs mb-8" data-id="element-49" data-mp="3ocgfui9r913m">
              Initiatives
            </h4>
            <ul className="space-y-4 text-white/60 text-sm" data-id="element-50" data-mp="3tc2umw58epej">
              <li data-id="element-51" data-mp="2agomjdlikigf">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-52" data-mp="2ah858wiznavi">
                  Green Harvest Africa
                </Link>
              </li>
              <li data-id="element-53" data-mp="21kfl5tdz79rn">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-54" data-mp="1wnywmy2v6te1">
                  Think Africa
                </Link>
              </li>
              <li data-id="element-55" data-mp="2pbuw2ajtizei">
                <Link to="/insights" className="hover:text-white transition-colors" data-id="element-56" data-mp="2pdfptxyb6ebb">
                  Research & Policy
                </Link>
              </li>
              <li data-id="element-57" data-mp="2fdosloid5l7j">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-58" data-mp="2fgay7ilp1qn4">
                  Youth Leadership
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-59" data-mp="2rv7s6610we50">
            <h4 className="text-brand-gold font-bold tracking-widest uppercase text-xs mb-8" data-id="element-60" data-mp="2ruog35y20jyw">
              Newsletter
            </h4>
            <p className="text-white/50 text-xs mb-6" data-id="element-61" data-mp="2wokbq1quhuqw">
              Receive strategic insights directly to your inbox.
            </p>
            <div className="flex" data-id="element-62" data-mp="2ntmgup4507wx">
              <input type="email" placeholder="Email" className="bg-white/5 border-none p-3 text-sm w-full outline-none focus:ring-1 focus:ring-brand-gold" data-id="element-63" data-mp="2nuxler5epjp3" />
              <button className="bg-brand-gold p-3" data-id="element-64" data-mp="3fkiqzhytbygi">
                <ArrowRight size={18} data-id="element-65" data-mp="31mc40wvejivm" />
              </button>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs tracking-widest text-white/30 uppercase font-bold" data-id="element-66" data-mp="36jkoj440vz01">
          <div data-id="element-67" data-mp="1v601ykpglgur">© 2026 Consilium Advisory. All Rights Reserved.</div>
          <div className="flex gap-8" data-id="element-68" data-mp="1v3dxwv1s1jha">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-69" data-mp="1nl69pz403nno">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-70" data-mp="1im35uhzrbnha">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};